import React, { useState } from "react";
import { FiMapPin, FiPhone, FiMail, FiClock, FiSend } from "react-icons/fi";
import { FaFacebookF, FaTwitter, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { useApp } from "../context/AppContext";

const contactInfo = [
  {
    icon: <FiMapPin />,
    title: "Visit Us",
    details: ["KG 123 Street, Kigali", "Rwanda, East Africa"],
  },
  {
    icon: <FiPhone />,
    title: "Call Us",
    details: ["+250799000000", "+250799000000"],
  },
  {
    icon: <FiMail />,
    title: "Email Us",
    details: ["info@homediscovery.rw", "support@homediscovery.rw"],
  },
  {
    icon: <FiClock />,
    title: "Working Hours",
    details: ["Mon - Fri: 8:00 AM - 6:00 PM", "Sat: 9:00 AM - 3:00 PM"],
  },
];

export default function Contact() {
  const { addNotification } = useApp();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      addNotification("Thank you! Your message has been sent successfully.", "success");
      setFormData({ name: "", email: "", subject: "", message: "" });
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="page-wrapper">
      {/* Header */}
      <div className="page-header">
        <div className="container position-relative text-center">
          <span className="badge bg-primary text-white fw-semibold px-3 py-2 rounded-pill mb-3">
            Contact Us
          </span>
          <h1>Get in Touch</h1>
          <p style={{ maxWidth: 600, margin: "0 auto" }}>
            Have a question or need help finding your dream home? We'd love to hear from you.
          </p>
        </div>
      </div>

      <section className="py-5">
        <div className="container">
          <div className="row g-4">
            {contactInfo.map((item, i) => (
              <div className="col-md-6 col-lg-3" key={i}>
                <div className="stat-card text-center p-4 h-100">
                  <div className={`stat-icon ${["blue", "green", "amber", "purple"][i]} mx-auto mb-3`}>
                    {item.icon}
                  </div>
                  <h6 className="fw-bold">{item.title}</h6>
                  {item.details.map((d, j) => (
                    <p key={j} className="text-muted small mb-1">{d}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5" style={{ background: "var(--gray-50)" }}>
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-7">
              <div className="contact-form-card">
                <h4 className="fw-bold mb-1" style={{ color: "var(--secondary)" }}>
                  Send us a Message
                </h4>
                <p className="text-muted mb-4">
                  Fill out the form and our team will get back to you within 24 hours.
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label fw-semibold small">Full Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        placeholder="John Doe"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        style={{ borderRadius: 10, border: "2px solid var(--gray-200)", padding: "0.75rem 1rem" }}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-semibold small">Email</label>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="you@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        style={{ borderRadius: 10, border: "2px solid var(--gray-200)", padding: "0.75rem 1rem" }}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label fw-semibold small">Subject</label>
                      <select
                        className="form-select"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                        style={{ borderRadius: 10, border: "2px solid var(--gray-200)", padding: "0.75rem 1rem" }}
                      >
                        <option value="">Select a subject</option>
                        <option value="buying">Buying a Property</option>
                        <option value="selling">Selling a Property</option>
                        <option value="renting">Renting a Property</option>
                        <option value="agent">Become an Agent</option>
                        <option value="support">General Support</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="form-label fw-semibold small">Message</label>
                      <textarea
                        className="form-control"
                        name="message"
                        rows={5}
                        placeholder="Tell us how we can help..."
                        value={formData.message}
                        onChange={handleChange}
                        required
                        style={{ borderRadius: 10, border: "2px solid var(--gray-200)", padding: "0.75rem 1rem" }}
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-primary rounded-pill px-5 py-2 fw-semibold d-flex align-items-center gap-2"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? (
                          <span className="spinner-border spinner-border-sm" role="status"></span>
                        ) : (
                          <FiSend />
                        )}
                        {loading ? "Sending..." : "Send Message"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="mb-4">
                <h4 className="fw-bold mb-3" style={{ color: "var(--secondary)" }}>
                  Follow Us
                </h4>
                <p className="text-muted">Stay connected and get the latest property updates.</p>
                <div className="d-flex gap-2">
                  {[
                    { icon: <FaFacebookF />, color: "#1877f2", label: "Facebook" },
                    { icon: <FaTwitter />, color: "#1da1f2", label: "Twitter" },
                    { icon: <FaInstagram />, color: "#e4405f", label: "Instagram" },
                    { icon: <FaWhatsapp />, color: "#25d366", label: "WhatsApp" },
                  ].map((social, i) => (
                    <a
                      key={i}
                      href="#!"
                      className="btn rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: 48,
                        height: 48,
                        background: `${social.color}15`,
                        color: social.color,
                        fontSize: "1.2rem",
                        transition: "all 0.3s",
                      }}
                      title={social.label}
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </div>

              <div
                className="rounded-4 p-4 text-white"
                style={{ background: "var(--gradient-primary)" }}
              >
                <h5 className="fw-bold mb-3">📍 Visit Our Office</h5>
                <p className="mb-3 opacity-75 small">
                  Come visit us at our Kigali office. We'd love to meet you in
                  person and discuss your property needs.
                </p>
                <div
                  className="rounded-3 d-flex align-items-center justify-content-center mb-3"
                  style={{ height: 180, background: "rgba(255,255,255,0.1)", backdropFilter: "blur(10px)" }}
                >
                  <div className="text-center">
                    <FiMapPin size={28} className="mb-2" />
                    <p className="mb-0 small">KG 123 St, Kigali</p>
                    <small className="opacity-75">Interactive map coming soon</small>
                  </div>
                </div>
                <p className="mb-0 small opacity-75">
                  <FiClock className="me-1" /> Mon-Fri: 8AM-6PM | Sat: 9AM-3PM
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
